import { Text } from "@chakra-ui/react"
import { useGlobalState } from "providers/globalState"

export default function Highlighter({ hit, text }) {
    const { site } = useGlobalState()

    if (!hit) return <Text as="span">{text}</Text>

    const searchTerms = site?.search?.terms.filter(token => !token.exclude).map(token => token.term.toLowerCase())

    if (!searchTerms?.length) return <Text as="span">{text}</Text>

    // split string by search terms AND keep the delimiters (search terms)
    const gluedTerms = searchTerms.join("|")
    const regExpString = "(" + gluedTerms + ")"
    let regEx
    try {
        regEx = new RegExp(regExpString, "i")
    } catch {
        return <Text as="span">{text}</Text>
    }
    const textParts = text.split(regEx)

    return (
        <Text as="span">
            {textParts.map((part, i) => {
                const isHighlighted = searchTerms.includes(part?.toLowerCase())
                return (
                    <Text as="span" className={isHighlighted ? "program__highlight" : null} bgColor={isHighlighted ? "#ffff00" : null} key={i}>
                        {part}
                    </Text>
                )
            })}
        </Text>
    )
}
